import api from '../api';
import { tokenService } from '../auth/tokenService';

export const experienceLevelService = {
  fetchExperiencelevel: async () => {
    try {
      const response = await api.get(`experience-levels/`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateExperienceLevel: async (id, experience) => {
    try {
      const response = await api.put(`experience-levels/${id}`, experience, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

}